angular.module('hcap-analytics')
  .service('SurveyBundleService', ['$http', function($http) {
    this.getBundle = function(cohortId, token) {
      return $http.get(`/api/surveyBundle/bundle/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}`).then(res => res.data);
    };

    this.authenticateBundle = function(cohortId, token) {
      return $http.post(`/api/surveyBundle/bundle/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/session`).then(res => res.data);
    };

    this.addBundleRater = function(cohortId, token, rater) {
      return $http.post(`/api/surveyBundle/bundle/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/raters`, rater).then(res => res.data);
    };

    this.resendBundleRater = function(cohortId, token, email) {
      return $http.post(`/api/surveyBundle/bundle/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/raters/notification/${encodeURIComponent(email)}`).then(res => res.data);
    };

    this.deleteBundleRater = function(cohortId, token, email) {
      return $http.delete(`/api/surveyBundle/bundle/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/raters/${encodeURIComponent(email)}`).then(res => res.data);
    };

    this.getRaterBundleState = function(participantGuid) {
      return $http.get(`/api/surveyBundle/raters/${encodeURIComponent(participantGuid)}/status`).then(res => res.data);
    };

    this.getAdminStatus = function(cohortId, token) {
      return $http.get(`/api/surveyBundle/bundle/admin/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/status`).then(res => res.data);
    };

    this.resendBundleInvitation = function(cohortId, token, userId) {
      return $http.post(`/api/surveyBundle/bundle/admin/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/users/${encodeURIComponent(userId)}/invitation`);
    };

    this.resendRaters = function(cohortId, token, participantGuid) {
      return $http.post(`/api/surveyBundle/bundle/admin/${encodeURIComponent(cohortId)}/${encodeURIComponent(token)}/participant/${encodeURIComponent(participantGuid)}/raters/notification`).then(res => res.data);
    };

    this.getCohortBundleStatus = function(cohortId) {
      return $http.get(`/api/surveyBundle/cohorts/${encodeURIComponent(cohortId)}/status`).then(res => res.data);
    };

    this.resendBundleInvitationCohort = function(cohortId, userId) {
      return $http.post(`/api/surveyBundle/cohorts/${encodeURIComponent(cohortId)}/users/${encodeURIComponent(userId)}/invitation`);
    };

    this.resendRatersCohort = function(cohortId, participantGuid) {
      return $http.post(`/api/surveyBundle/cohorts/${encodeURIComponent(cohortId)}/participant/${encodeURIComponent(participantGuid)}/raters/notification`).then(res => res.data);
    };

    this.getAllAdmin = function() {
      return $http.get('./api/surveyBundle/admin/all').then(res => res.data);
    };

    this.getAdmin = function(guid) {
      return $http.get('./api/surveyBundle/admin/' + guid).then(res => res.data);
    };

    this.createAdmin = function() {
      return $http.put('./api/surveyBundle/admin').then(res => res.data);
    };

    this.updateAdmin = function(guid, bundle) {
      var obj = {
        name: bundle.name,
        portal: bundle.portal,
        active: bundle.active,
        assessmentGuids: bundle.assessmentGuids,
      };
      return $http.post('./api/surveyBundle/admin/' + guid, obj).then(res => res.data);
    };

    this.deleteAdmin = function(guid) {
      return $http.delete('./api/surveyBundle/admin/' + guid).then(res => res.data);
    };
  }]);
